import { render } from "./itemSlider.vue?vue&type=template&id=b7eafe82&scoped=true"
import script from "./itemSlider.vue?vue&type=script&lang=js"
export * from "./itemSlider.vue?vue&type=script&lang=js"

import "./itemSlider.vue?vue&type=style&index=0&id=b7eafe82&scoped=true&lang=css"

import exportComponent from "C:\\HAZAKPUEBLA\\cedispage2.0jacve\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7eafe82"]])

export default __exports__